


function parseData(data) {
  if ((!data) || data.length == 0) {
    return null;
  } else {
    return JSON.stringify(data);
  }
}

function serviceFactory({ api }) {


  const init = ({ metaData }) =>
    api
      .init(metaData)
      .then(parseData);


  const search = ({ inputParam, metaData }) =>
    api
      .search(inputParam, metaData)
      .then(parseData);


  const finalize = ({ base64Contracts, base64DataObj, metaData }) =>
    api
      .finalize(base64Contracts, base64DataObj, metaData)
      .then(parseData);
  
  const finalizeChunk = ({ base64DataObj, metaData }) =>
    api
      .finalizeChunk(base64DataObj, metaData)
      .then(parseData);

  const uploadHistory = ({ inputParam, metaData }) =>
    api
      .uploadHistory(inputParam, metaData)
      .then(parseData);

  const download = ({ inputParam, metaData }) =>
    api
      .download(inputParam, metaData)
      .then(parseData);


  return {
    init,
    search,
    finalize,
    finalizeChunk,
    uploadHistory,
    download
  }
}

module.exports = serviceFactory;
